import React, { createContext, useContext, useState } from "react";
import { axiosMaster } from "../api/axiosInstance";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user"))
  );

  const [permissions, setPermissions] = useState(
    JSON.parse(localStorage.getItem("permissions")) || []
  );

  /* ================= LOGIN ================= */
  const login = async (data) => {
    localStorage.setItem("token", data.token);
    localStorage.setItem("refreshToken", data.refreshToken);

    const userData = {
      userId: data.user_Id,
      name: data.user_Name,
      roleId: data.roleId,
      role: data.roleName,
      userTypeId: data.userTypeId,
      restaurantId: data.restId,
      groupId: data.groupId,
      restaurantName: data.restaurantName,
     groupName: data.groupName,
    };

    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);

    // 🔥 FETCH USER ROLE AFTER LOGIN
    await fetchPermissions(userData);
  };

  /* ================= FETCH PERMISSIONS ================= */
  const fetchPermissions = async (userData) => {
    try {
      const res = await axiosMaster.get(
        `/UserRole/GetUserRole?groupId=${userData.groupId}&restId=${userData.restaurantId}&userId=${userData.userId}`
      );

      const roleAccesses = res.data?.roleAccesses || [];

      localStorage.setItem("permissions", JSON.stringify(roleAccesses));
      setPermissions(roleAccesses);

    } catch (err) {
      console.error("Permission fetch error:", err);
    }
  };

  /* ================= CHECK ACCESS ================= */
const hasAccess = (moduleId, type = "read") => {
  if (user?.role === "Super Admin") return true;

  if (!permissions || permissions.length === 0) return true;

  const module = permissions.find((m) => m.moduleId === moduleId);

  return module ? module[type] === true : false;
};

  /* ================= LOGOUT ================= */
  const logout = () => {
    localStorage.clear();
    setUser(null);
    setPermissions([]);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider
      value={{ user, permissions, login, logout, hasAccess }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);